import {useNavigate} from 'react-router-dom';
import {useKeyMomentActiveFilters} from "../contexts/application/KeyMomentActiveFilters";
import {useContentSpecificParams} from "../contexts/ContentSpecificParamsContext";
import {getSubRoot} from "../utils/utils";
import {
    CONTENT_AGGREGATION_PAGE_NAME,
    CURRENT_SPORT,
    LIBRARY_PAGE_NAME,
    SUPPORTED_CONTENTS,
    SUPPORTED_SPORTS
} from "../constants/globalConstants";
import {useSelectedCard} from "../contexts/SelectedCardContext";

export const usePageJump = () => {
    const navigate = useNavigate();
    const { setKeyMomentActiveFilters } = useKeyMomentActiveFilters()
    const { contentSpecificParams} = useContentSpecificParams()
    const { setPreviousPage, setExcludedFilters } = useSelectedCard()

    const libraryJump = (contentType: string) => {
        const navPath = getSubRoot(window.location.pathname) + "/keymoments/" + LIBRARY_PAGE_NAME;

        if (SUPPORTED_CONTENTS[CURRENT_SPORT as keyof typeof SUPPORTED_SPORTS].MATCH_HIGHLIGHT === contentType && contentSpecificParams){
            setKeyMomentActiveFilters({
                competitionFilterValues: [contentSpecificParams?.competition],
                matchFilterValues: [contentSpecificParams?.match]
            });
            setExcludedFilters(['matchFilterValues', 'competitionFilterValues']);
        }
        else if ( CURRENT_SPORT === SUPPORTED_SPORTS.FOOTBALL && SUPPORTED_CONTENTS[CURRENT_SPORT].GOAL_PARADE === contentType && contentSpecificParams){
            setKeyMomentActiveFilters({
                competitionFilterValues: [contentSpecificParams?.competition],
                matchDayFilterValues: [contentSpecificParams?.matchday],
                keyMomentTypeValues: [{id: "GOAL", value: "Goal"}]
            })
            setExcludedFilters(['competitionFilterValues', 'matchDayFilterValues', 'keyMomentTypeValues']);
        }else if (SUPPORTED_CONTENTS[CURRENT_SPORT].CLIP === contentType){
            setKeyMomentActiveFilters({})
            setExcludedFilters([])
        }

        setPreviousPage(`${CONTENT_AGGREGATION_PAGE_NAME}/${(contentType || '').toLowerCase()}`);
        navigate(navPath);
    };

    return {libraryJump};
};